

const sessionStorageKeys = {
    greek1: 'ltrgen-greek-1',
    greek2: 'ltrgen-greek-2',
    greek3: 'ltrgen-greek-3'
  };
  
  const getSessionKey = (i) => {
  if (i === 1) {
    return sessionStorageKeys.greek1;
  
  } else if (i == 2) {
    return sessionStorageKeys.greek2;
    
  } else if (i == 3) {
    return sessionStorageKeys.greek3;
  
  }
  }
  
  class LetterGenerator extends HTMLElement {
    constructor() {
        super();
  
        this.productInfo = this.closest('product-info');
  
        this.generator = {
            default: {
                pattern: this.dataset.defaultPattern1 || 'https://something-greek.s3.amazonaws.com/GG7034.jpg',
                border: this.dataset.defaultBorder1 || 'https://something-greek.s3.amazonaws.com/BrownBd.jpg'
            }, // test 123 test 123 test 123 test 123
            letters: {
                roots: [],
                letter: {
                    id: 'letter',
                    paths: [],
                    images: [],
                },
                border: {
                    id: 'border',
                    paths: [],
                    images: [],
                }
            },
            active: {
                gallery: {
                    isOpen: false,
                    isAbove: false,
                    type: '',
                    dom: this.querySelector('.letter-generator__active-gallery'),
                    loaded: {
                        patterns: [],
                        borders: [],
                        letters: [],
                        garments: [
                            [], 
                            []
                        ],
                        letters: [],
                        otherOptions: [
                            [],
                            []
                        ]
                    },
                },
                product: 1,
                letter: 0,
            },
            domOptions: [
                /*
                {
                    title: '',
                    type: '',
                    optionDom: null,
                    buttonDom: null,
                    activeProduct: 1 product || 2 product || 0 letters
                    activeValue
                }
                */
            ],
        }
  
        this.settings = {
            isCustomization: false,
            isFree: true,
            isGroup: false,
            isPackage: false,
            isSigmaIotaAlpha: false,
            isSpecialGroup: false, // Special groups = Farmhouse, ACACIA, Etc
            
            specialProductType: '',

            defaultLetters: [],
            useSavedData: false,
            usesFourthLetter: false,
        }
  
        this.apiData = {
            patterns: [],
            borders: [],
            garments: [
                [],
                []
            ],
            letters: [],
            letterPaths: {
                letter: [],
                border: []
            },
        };
  
  
        this.shopifyProuctStyles = [];
        this.memoedImages = [];
    }
  
    activate() {
        const target = this.productInfo.querySelector('bold-option-hooker');
        if (!target) return;
  
        const config = { attributes: true };
        const observer = new MutationObserver(waitForBoldHookerToLoadCallback);
        observer.observe(target, config);
  
        const loadLetters = () => this.showLetters();
  
        function waitForBoldHookerToLoadCallback(mutationList) {
            mutationList.forEach((mutation) => {
                switch (mutation.type) {
                  case "attributes":
                    if (mutation.target.dataset.loaded == 'true') {
                        loadLetters();
                        observer.disconnect();
                    }
                    break;
                }
            });
        }
    }
  
    showLetters() {
        this.classList.add('letter-generator--active');
  
        const defaultLetters = () => {
          const greekLetter1 = this.settings.defaultLetters[0];
  
          if (greekLetter1.includes('FIJI') || greekLetter1.includes('fiji')) {
            return ['fiji_f', 'fiji_i', 'fiji_j', 'fiji_i'];
  
          } else if (greekLetter1 == 'Sigma Alpha Epsilon Pi' || greekLetter1 == 'sigma alpha epsilon pi') {
            return greekLetter1.toLowerCase().split(' ');
          }
  
          return this.settings.defaultLetters;
        }
        
  
        setTimeout(() => {
          const letters = defaultLetters();
          const useDefaultPattern = this.settings.specialProductType == 'starsandstripes' ? false : true;
  
          letters.forEach((letter, i) => {
              this.setLetter(i + 1, letter, useDefaultPattern);
              this.updateSVG(i + 1);
  
              if (i > 1 && letters.length == 4) this.hideSVGCaption(i);
          });
        }, 100);
    }
  
    connectedCallback() {
        // Get and parse data from Shopify
        // Fetch data using Shpify Vars
        this.parseShopifyTag();
       
  
  
        // Do nothing until Bold Hooker
        // calls init() with an array of bold option sets;
        
    }
  
    prepareBoldData(boldOptionSets) {
        if (!boldOptionSets || boldOptionSets.length === 0 || !boldOptionSets[0].classList.contains('bold_option_set')) return;
  
        //console.log('BOLD DATA LOADED:', boldOptionSets);
        
        this.prepareAPIData();
  
        // Add dom and other data to this.generator.domOptions
        this.#populateGeneratorDomOptions(boldOptionSets);
      
  
        // Render Buttons For Opening Gallery
        this.#generateOptionNavigation();
  
        // Detect scroll for active gallery
        this.watchGalleryScroll();
  
        // Start building gallery cards
        this.#generateGalleryCards(boldOptionSets);
        this.generateGalleryTextCards(boldOptionSets);
  
        // Setup Package deals
        if (this.settings.isPackage) this.#setupProductSelectorButtons();
  
        // Init Main Functions
        // Create Letter Element
        this.initLetters();
          
        console.log(`\n\nspecialtype\n\n`, this.settings);
        if (this.settings.specialProductType != '') this.#setupSpecialProductType();

        this.activate();
  
        console.log('settings', this.settings);
  
        console.log('apidata', this.apiData);    
        
        console.log('generator', this.generator);
    }

    #setupSpecialProductType() {
        if (this.settings.specialProductType == '') return;
        console.log('special');

        /* Handle Hidden Input for Special Items (Border Only / Letter Only Products) */

        const imgStripes = 'https://www.somethinggreek.com/cdn/shop/files/StripesOnly.jpg?v=1761762773&width=600';
        const imgStars = 'https://www.somethinggreek.com/cdn/shop/files/Stars_stripesblueLG.jpg?v=1761691612&width=600';

        const patternImages = [
            imgStars,
            imgStripes,
            imgStripes
        ];

        if (this.settings.usesFourthLetter) {
            const fourthImage = patternImages.length > 1 ? patternImages[patternImages.length - 1] : patternImages[0];
            patternImages.push(fourthImage);
        }

        this.generator.letters.roots.flatMap((rootEle) => rootEle.querySelector('.letter-image'))
            .forEach((letter, i) => {
                console.log('for each node name', letter, patternImages[i]);
                if (letter.getAttribute('href') !== patternImages[i]) {
                    if (letter.nodeName === 'DIV') {
                        letter.style.backgroundImage = `url('${patternImages[i]}')`;
                        letter.style.transform = 'translateX(0)';
                    } else if (letter.nodeName == 'image' || letter.nodeName == 'IMAGE') {
                        letter.setAttribute('href', patternImages[i]);
                    }
                }
            });

        const borderImage = 'https://www.somethinggreek.com/cdn/shop/files/Border_Red.jpg';

        this.generator.letters.roots.flatMap((rootEle) => rootEle.querySelector('.border-image'))
            .forEach((letter) => {
                if (letter.getAttribute('href') !== borderImage || borderImage == '') {
                    if (letter.nodeName === 'DIV') {
                        letter.style.backgroundImage = `url('${borderImage}')`;
                        letter.style.transform = 'translateX(0)';
                    } else if (letter.nodeName == 'image' || letter.nodeName == 'IMAGE') {
                        letter.setAttribute('href', borderImage);
                    }
                }
            });

        console.log(this.generator);
    }
  
    #setupProductSelectorButtons() {
        if (!this.settings.isPackage) return false;
        const menuConstants = {
            p1: 'Product 1',
            p2: 'Product 2',
            cp1: 'Paste from Product 1',
            cp2: 'Paste from Product 2',
        }
  
        const selectorWrapper = document.createElement('div');
        selectorWrapper.innerHTML = `
        <nav class="main-menu tw-flex tw-justify-between tw-mb-8" aria-label="Main Menu">
            <div class="menu-switch-product text-left tw-flex">
                <button id="change-product-1" class="product-1 active-product color-scheme-5 button button--secondary" data-product="1">
                    ${menuConstants.p1}
                </button>
                <button id="change-product-2" class="product-2 color-scheme-5 button button--primary" data-product="2">
                    ${menuConstants.p2}
                </button>
            </div>
  
            <div class="menu-copy-product text-right">
                <button id="copy-product" class="copy-product button button--tertiary">
                    ${menuConstants.cp2}
                </button>
            </div>
        </nav>
        `;
  
        // setup copy product buttons
        const copyProductButton = selectorWrapper.querySelector('.copy-product');
        copyProductButton.style.display = 'none';
  
        const mapOption = (from, to) => {
            if (from.length !== to.length) return [];
  
            // Sort the options to make sure that the types match up
            const targetOptions = to.sort((a, b) => a.type > b.type ? 1 : -1);
            const hostOptions = from.sort((a, b) => a.type > b.type ? 1 : -1);
            
  
            for (let i = 0; i < hostOptions.length; i++) {
                const targetOption = targetOptions[i];
                const hostOption = hostOptions[i];
  
                this.setBoldOption(targetOption, hostOption.activeValue);
                this.setNavigationText(targetOption, hostOption.activeValue);
            }
        }
        copyProductButton.addEventListener('click', (e) => {
            e.preventDefault();
            
            const p1 = this.generator.domOptions.filter((option) => option.activeProduct === 1);
            const p2 = this.generator.domOptions.filter((option) => option.activeProduct === 2);
            
  
            if (this.generator.active.product === 1) {
                mapOption(p2, p1);
  
            } else {
                mapOption(p1, p2);
  
            }
        });
  
        // setup switch product buttons
        const productSwitchButtons = [...selectorWrapper.querySelectorAll('.menu-switch-product > button')];
        productSwitchButtons.forEach((button) => {
            const setActiveIndex = parseInt(button.dataset.product);
  
            const updateButton = productSwitchButtons.filter((updateButton) => parseInt(updateButton.dataset.product) != setActiveIndex)[0];
  
            button.addEventListener('click', (e) => {
                e.preventDefault();
  
                const updateProductNum = parseInt(e.target.dataset.product);
                copyProductButton.textContent = updateProductNum === 1 ? menuConstants.cp2 : menuConstants.cp1;
  
                if (this.generator.active.product != updateProductNum) {
                    updateButton.className = updateButton.className.replace('button--secondary','button--primary');
                    e.target.className = e.target.className.replace('button--primary', 'button--secondary');
  
                    this.switchProductDisplay(updateProductNum, copyProductButton);
                    console.log(this.generator);
                }
            });
        });
        
  
        this.prepend(selectorWrapper);
    }
  
    toggleCopyOptionsButton(boldOptionObj, copyProductButton) {
        if (!boldOptionObj) return;
  
        const showCopyOptionsButton = boldOptionObj.filter((boldOption) => boldOption.activeValue !== '').length > 0;
        copyProductButton.style.display = !showCopyOptionsButton ? 'none' : 'inline-block';
  
        console.log('from togglecopy options', showCopyOptionsButton, boldOptionObj);
  
        // Modal popup for after switching products
        // Removed for now 4.29.24
        /*
        const testModal = document.createElement('dialog');
        testModal.id = 'dialog-test';
        testModal.innerHTML = `
            <button autofocus>Close</button>
  
            <p>Switched to Product ${}</p>
        `;
        document.body.append(testModal);
        testModal.showModal();
        setTimeout(() => testModal.remove(), 1000);
        */
    }
  
    switchProductDisplay(updateIndex, copyProductButton) {
        // Close gallery for a reset
        this.hideActiveGallery();
  
        // switch garment & size option cards
        const buttonsToShow = this.generator.domOptions.filter((option) => option.activeProduct == parseInt(updateIndex));
        const buttonsToHide = this.generator.domOptions.filter((option) => option.activeProduct != parseInt(updateIndex) && option.activeProduct !== 0);
  
        this.toggleCopyOptionsButton(buttonsToHide, copyProductButton);
  
        // switch visibility
        buttonsToHide.forEach((button) => button.buttonDom.style.display = 'none');
        buttonsToShow.forEach((button) => button.buttonDom.style.display = 'block');
        
        this.generator.active.product = parseInt(updateIndex);
    }
  
  
  
    watchGalleryScroll(removeCurrentListener = false) {
        const galleryList = this.generator.active.gallery.dom;
        if (removeCurrentListener) galleryList.removeEventListener('scroll', handleScroll);
        galleryList.addEventListener('scroll', handleScroll);
  
        const moreElementsToGenerate = () => {
  
        };
  
        function handleScroll() {
            const container = galleryList;
            const scrollPosition = container.scrollTop + container.clientHeight;
            const totalHeight = container.scrollHeight;
  
            if (scrollPosition >= totalHeight - 200) { // Adjust this threshold as needed
                // console.log('reached bottom');
  
                if (moreElementsToGenerate) {
                    //generateElements();
                } else {
                    //galleryList.removeEventListener('scroll', handleScroll);
                }
            }
            
            const scrollDirection = container.scrollTop > container.lastScrollTop ? 'down' : 'up';
  
            if (scrollDirection === 'down') {
                //console.log('scrollin down');
                // Scroll down, add more elements at the bottom
                //startIndex = endIndex + 1;
                //endIndex += 20; // Add more elements, adjust as needed
               //generateElementsInRange(startIndex, endIndex);
            } else {
               // console.log('scrollin up');
                // Scroll up, remove elements at the bottom
                //startIndex -= 20; // Remove elements, adjust as needed
                //endIndex -= 20;
                //removeElementsOutsideRange(startIndex, endIndex);
            }
  
            container.lastScrollTop = container.scrollTop;
        }
    }
  
  
  
    openActiveGallery(updateType = '', updateLetter = 0) {
        const activeGallery = this.generator.active.gallery;
        if (!activeGallery) return;
  
        let targetElement;
  
        // Check if the active gallery is above or below the option navigation
        // This determines whether we move it or not
        if (updateType === 'letter' && !activeGallery.isAbove) {
            targetElement = activeGallery.dom.parentElement.querySelector('.output');
            activeGallery.isAbove = true;
  
        } else if (updateType !== 'letter' && activeGallery.isAbove) {
            targetElement = activeGallery.dom.parentElement.querySelector('.letter-generator__option-navgiation');
            activeGallery.isAbove = false;
        }
  
        // Only time this doesn't change is when it is already 
        // below, so we don't need to move it
        if (targetElement) {
            targetElement.after(activeGallery.dom);
        }
  
  
        // Handle switching galleries below
        const mainGenerator = this.generator;
        const activeGenerator = mainGenerator.active;
  
        if (activeGallery.isOpen) {
            if ((updateType === 'letter' && activeGenerator.letter !== updateLetter) || (activeGallery.type !== updateType)) {
                this.updateActiveGallery(updateType, updateLetter);
  
            } else {
                this.hideActiveGallery();
            }
        } else {
            this.showActiveGallery(updateType, updateLetter);
        }
    }
  
    getRelativeBoldOption(updateType) {
        const domOptions = this.generator.domOptions;
  
        if (updateType === 'letter') {
            return domOptions.find((option) => option.type === updateType && option.title.includes(this.generator.active.letter));
  
        } else if (this.settings.isPackage) {
          return domOptions.filter((options) => options.activeProduct == this.generator.active.product).find((option) => option.type === updateType);
        
        } else {
            return domOptions.find((option) => option.type === updateType);
        }
    }
  
    setActiveGalleryTitle(updateType) {
        const listTitle = this.generator.active.gallery.dom.firstElementChild;
        const relativeBoldOption = this.getRelativeBoldOption(updateType);
  
        const updatedTitle = updateType === 'letter' ? relativeBoldOption.title.replace(/\s(1|2|3)/, `${' ' + this.generator.active.letter}`) : relativeBoldOption.title;
  
        listTitle.textContent = updatedTitle;
    }
  
    setActiveGalleryList(updateType, updateLetter = -1) {
        const galleryList = this.generator.active.gallery.dom.lastElementChild;
        const newGallery = this.getLoadedGallery(updateType, updateLetter);
      console.log('new gall', newGallery, galleryList);
  galleryList.replaceChildren(...newGallery);
      
      /*
        if (updateLetter === 1) {
            galleryList.replaceChildren(...newGallery.slice(1));
        } else {
            galleryList.replaceChildren(...newGallery);
        }
        */
    }
  
    updateActiveGallery(updateType, updateLetter) {
        if (!this.generator.active.gallery.isOpen) return;
  
        const activeGenerator = this.generator.active;
        activeGenerator.letter = updateLetter > 0 ? updateLetter : 0;
        activeGenerator.gallery.isOpen = true;
        activeGenerator.gallery.type = updateType;
  
        this.setActiveGalleryTitle(updateType);
        this.setActiveGalleryList(updateType, updateLetter);
    }
  
    hideActiveGallery() {
        if (!this.generator.active.gallery.isOpen) return;
  
        const activeGenerator = this.generator.active;
        activeGenerator.letter = 0;
        activeGenerator.gallery.isOpen = false;
  
        return setTimeout(() => activeGenerator.gallery.dom.classList.remove('letter-generator__active-gallery--open'), 250);
    }
  
    showActiveGallery(updateType, updateLetter) {
        const activeGenerator = this.generator.active;
  
        activeGenerator.letter = updateLetter > 0 ? updateLetter : 0;
        activeGenerator.gallery.isOpen = true;
        activeGenerator.gallery.type = updateType;
  
        this.setActiveGalleryTitle(updateType);
        this.setActiveGalleryList(updateType, updateLetter);
  
        return setTimeout(() => activeGenerator.gallery.dom.classList.add('letter-generator__active-gallery--open'), 250);
    }
  
    getLoadedGallery(type, updateLetter = 1) {
        const loadedGallery = this.generator.active.gallery.loaded;
  
        switch(type) {
            case 'letter':
                return loadedGallery.letters[0].data;
            
            case 'pattern':
                return loadedGallery.patterns;
  
            case 'border':
                return loadedGallery.borders;
  
            case 'garment':
                return loadedGallery.garments[this.generator.active.product - 1];
            
            default:
                const activeProductOptions = loadedGallery.otherOptions[this.generator.active.product - 1];
                const foundOption = activeProductOptions.filter((option) => this.convertOptionTitleToGalleryType(option.title) === type); 
  
                
                const updateLetterIndex = updateLetter <= 0 ? 0 : updateLetter - 1;
            console.log('in default', activeProductOptions,  updateLetterIndex, this.generator.active.gallery.loaded);
                return foundOption[updateLetterIndex].data || [];
        }
    }
  
    useMultiFiles(cardSettings) {
        if (!cardSettings.file2 && !cardSettings.file3) {
            return false;
        } else if (cardSettings.file2 != '' && cardSettings.file3 != '') {
            if (cardSettings.file2 !== cardSettings.file3 || cardSettings.file3 !== cardSettings.file1) {
                return true;
            }
        }
  
        return false;
    }
  
    #createGalleryCard(type, option, flag = 'image') {
        if (!option || type == '') return null;
        // First Get Default Values Because Dataset Is Not Consistent
        const getOptionId = (type) => {
            switch(type) {
                case 'garment':
                case 'border':
                case 'pattern':
                    return option.id;
  
                default:
                    return option.value
            }
        }
        const optionId = getOptionId(type);
        const isTextCard = flag !== 'image';
        
  
        // Final Creation Of Element
        const rootElement = document.createElement('li');
        rootElement.id = `${type}-card__${optionId}`;
        rootElement.className = 'lg-gallery-card';
        rootElement.setAttribute('aria-labelledby', `lg-card-caption__${type}-${optionId}`);
        
        const cardSettings = {
            type: type,
            target: '',
            letterSvgPath: '',
            letterSvgOffset: '',
            captionText: '',
            thumbFile1: '',
            file1: '',
            file2: '',
            file3: '',
        };
  
        if (type === 'letter') {
            // Set Data for Selecting Letters
            cardSettings.target = option.label;
            cardSettings.file1 = option.file;
            cardSettings.captionText = option.label.charAt(0).toUpperCase() + option.label.slice(1);
  
            if (cardSettings.target.includes('FIJI')) {
                cardSettings.fourthLetterGeneratorTargets = 'fiji_f, fiji_i, fiji_j, fiji_i';
            } else if (cardSettings.target.includes('Sigma Alpha Epsilon Pi')) {
                cardSettings.fourthLetterGeneratorTargets = 'sigma, alpha, epsilon, pi';
            }
  
        } else if (isTextCard) {
            cardSettings.target = option.value;
            cardSettings.captionText = option.textContent.trim().replace('[', '<br><span class="caption">[').replace(']', ']</span>').replace('.00', '');
  
        } else if (type === 'garment') {
          cardSettings.target = option.label;
          cardSettings.file1 = option.src_background;
          cardSettings.captionText = option.label;
          cardSettings.fileGallery = option.src_gallery;
        
        } else {
            // Set data for api data, eg. patterns, borders, garments
            cardSettings.target = option.target || option.target2;
            cardSettings.file1 = option.file;
            cardSettings.file2 = option.file2 != '' ? option.file2 : '';
            cardSettings.file3 = option.file3 != '' ? option.file3 : '';
            cardSettings.captionText = type === 'pattern' ? option.target.replace(/Pattern\s?/, '') : option.target;

            if (type === 'pattern' && option.thumbFile1) {
                cardSettings.thumbFile1 = option.thumbFile1;
            }
        }

      if (isTextCard) {
        rootElement.className += ' lg-gallery-card--text-card ';
      }
  
        // Remove Extra Settings
        const settingsToRemove = Object.entries(cardSettings).filter(([key, value]) => value === '');
        settingsToRemove.forEach((setting) => delete cardSettings[setting]);
  
  
  
        // Setup Click Actions for Cards
        const clickableCard = document.createElement('button');
        clickableCard.setAttribute('aria-label', `Change ${type.charAt(0).toUpperCase() + type.slice(1)} to ${cardSettings.target.charAt(0).toUpperCase() + cardSettings.target.slice(1)}`);
  
        const generateImageBlock = () => {
            const useMulti = this.useMultiFiles(cardSettings);
            let IMG_WIDTH = 125;
            let IMG_HEIGHT = 125;
            
            if (useMulti) {
                IMG_WIDTH = IMG_HEIGHT / 3;

                return `
                    <div class="tw-grid tw-grid-cols-3">
                        <img src="${cardSettings.file1}" 
                            width="${IMG_WIDTH}"
                            height="${IMG_HEIGHT}"
                            loading="lazy"
                            style="display: inline-block; aspect-ratio: 1/3;"
                        />
                        <img src="${cardSettings.file2}" 
                            width="${IMG_WIDTH}"
                            height="${IMG_HEIGHT}"
                            loading="lazy"
                            style="display: inline-block; aspect-ratio: 1/3;"
                        />
                        <img src="${cardSettings.file3}" 
                            width="${IMG_WIDTH}"
                            height="${IMG_HEIGHT}"
                            loading="lazy"
                            style="display: inline-block; aspect-ratio: 1/3;"
                        />
                    </div>
                `;
            }
  
            const cardDimension = (dimension = 'x') => {
                switch(dimension) {
                    case 'y':
                        if (type === 'letter') {
                            return IMG_HEIGHT / 2;
                        }

                        return IMG_HEIGHT;

                    // case 'x':
                    default:
                        return IMG_WIDTH;
                }

                return IMG_WIDTH;
            }

            const thumbFile1 = cardSettings.thumbFile1 ? cardSettings.thumbFile1 : cardSettings.file1;
  
            return `
                <img src="${cardSettings.fileGallery ? cardSettings.fileGallery : thumbFile1}" 
                    width="${cardDimension('x')}"
                    height="${cardDimension('y')}"
                    loading="lazy"
                />
            `;
        }
  
        if (!isTextCard) {
            clickableCard.innerHTML = `
                <figure aria-labelledby="lg-card-caption__${type}-${optionId}">
                    ${generateImageBlock()}
                    
                    <figcaption id="lg-card-caption__${type}-${optionId}">${cardSettings.captionText}</figcaption>
                </figure>
            `;
  
        } else {
            clickableCard.id = `lg-card-caption__${type}-${optionId}`;
            clickableCard.innerHTML = cardSettings.captionText.replace(',', '<br>');
  
        }
        
  
        const transitionContainer = (container, imageSrc = '') => {
            const memoedLength = this.memoedImages.length;
            const memoedImage = this.memoedImages.find((memo) => memo.imageSrc === imageSrc);
            let targetSrc = imageSrc;
  
            if (targetSrc === '') {
                hideContainer();
                showContainer();
                
            } else if (!memoedImage  && targetSrc != '') {
                const waitForImage = new Image();
                waitForImage.src = imageSrc;
  
                waitForImage.onload = (e) => {
                    hideContainer();
                    this.memoedImages.push({
                        imageSrc: imageSrc,
                        imageEle: waitForImage,
                    });
                    showContainer();
                }
            } else {
                hideContainer();
                targetSrc = memoedImage.imageEle.src;
                showContainer();
            }
  
            function hideContainer() {
                container.style.opacity = 0;
    
                if (container.nodeName === 'DIV') {
                    container.style.transform = 'translateY(-5%)';
                }
            }
    
            function showContainer() {
                setTimeout(() => {
                    container.style.opacity = 1;
                    
    
                    if (container.nodeName === 'DIV') {
                        container.style.backgroundImage = `url('${targetSrc}')`;
                        container.style.transform = 'translateX(0)';
                    } else if (container.nodeName == 'image' || container.nodeName == 'IMAGE') {
                        container.setAttribute('href', targetSrc);
                    }
                }, 400 + 20 * memoedLength % 5);   
            }
        };
        
  
        clickableCard.addEventListener('click', (e) => {
            e.preventDefault();
  
            console.log('clicked clickable', clickableCard);
  
            const updateValue = cardSettings.target;
            cardSettings.activeValue = updateValue;
            const relativeBoldOption = this.getRelativeBoldOption(type);
  
            // Update Bold Option
            if (cardSettings.target.includes('FIJI') || cardSettings.target.includes('Sigma Alpha Epsilon Pi')) {
                const previousLetterVal = this.generator.active.letter;
  
                [1, 2, 3].forEach((num) => {
                    this.generator.active.letter = num;
                    let tempUpdateValue = num === 1 ? cardSettings.target : '*Not Applicable';
                    let tempRelativeBoldOption = this.getRelativeBoldOption(type);
  
                    this.setBoldOption(tempRelativeBoldOption, tempUpdateValue);
                });
  
                this.generator.active.letter = previousLetterVal;
            } else {
                
                this.setBoldOption(relativeBoldOption, updateValue);
                if (type === 'garment') this.setBoldOptionViaGuess(relativeBoldOption, updateValue);
            }
  
            // Update navigation button labels
            if (type !== 'letter') {
                this.setNavigationText(relativeBoldOption, updateValue);
            } 
  
  
            
  
            // Update Generator
  
            switch(type) {
                case 'pattern':
                    const patternImages = [
                        cardSettings.file1,
                        (cardSettings.file2 && cardSettings.file2 != '') ? cardSettings.file2 : cardSettings.file1,
                        (cardSettings.file3 && cardSettings.file3 != '') ? cardSettings.file3 : cardSettings.file1
                    ];
  
                    if (this.settings.usesFourthLetter) {
                        const fourthImage = patternImages.length > 1 ? patternImages[patternImages.length - 1] : patternImages[0];
                        patternImages.push(fourthImage);
                    }
  
                    relativeBoldOption.activeFiles.length = 0;
                    relativeBoldOption.activeFiles.push(...patternImages);
  
                    if (relativeBoldOption.hiddenDom != '') {
                        relativeBoldOption.hiddenDom.value = patternImages.join(', ');
                    }
  
                    this.generator.letters.roots.flatMap((rootEle) => rootEle.querySelector('.letter-image'))
                        .forEach((letter, i) => {
                            if (letter.getAttribute('href') !== patternImages[i]) transitionContainer(letter, patternImages[i]);
                        });
                    break;
  
                case 'border':
                    const fileLowercase = cardSettings.file1.toLowerCase();
                    const isNoBorder = fileLowercase.includes('no') && fileLowercase.includes('border');
                    const borderImage = isNoBorder ? '' : cardSettings.file1;
                    console.log('\n\n\nborder image', borderImage, isNoBorder, fileLowercase);
                    relativeBoldOption.activeFiles.length = 0;
                    relativeBoldOption.activeFiles.push(borderImage);
  
                    if (relativeBoldOption.hiddenDom != '') {
                        relativeBoldOption.hiddenDom.value = borderImage;
                    }
  
                    this.generator.letters.roots.flatMap((rootEle) => rootEle.querySelector('.border-image'))
                        .forEach((letter) => {
                            if (letter.getAttribute('href') !== borderImage || borderImage == '') transitionContainer(letter, borderImage)
                        });
                    break;
  
                    
  
                case 'garment':
                    const garmentContainer = this.querySelector('.garment-image');
                    const garmentImage = cardSettings.file1;
                    relativeBoldOption.activeFiles.length = 0;
                    relativeBoldOption.activeFiles.push(garmentImage);
  
                    if (relativeBoldOption.hiddenDom != '') {
                        relativeBoldOption.hiddenDom.value = garmentImage;
                    }
  
                    //garmentContainer.style.backgroundImage = `url('${garmentImage}')`;
                    if (garmentImage != garmentContainer.style.backgroundImage || garmentImage == '') transitionContainer(garmentContainer, garmentImage);
                    break;
  
                case 'letter':
                    const currentIndex = this.generator.active.letter;
                    if (currentIndex === 0) break;
  
                    if ((cardSettings.target.includes('FIJI') || cardSettings.target.includes('Sigma Alpha Epsilon Pi')) && !this.settings.usesFourthLetter) {
                        const letterContainer = this.querySelector('.output__letters-list');
                        const rootLetters = [...this.generator.letters.roots].flatMap((root) => [...root.querySelectorAll('image')]);
                        rootLetters.forEach((image) => transitionContainer(image, image.getAttribute('href')));
  
                        setTimeout(() => {
                            const targets = cardSettings.fourthLetterGeneratorTargets.split(', ');
                            let curentActiveLetter = this.generator.active.letter;
                            this.settings.usesFourthLetter = !this.settings.usesFourthLetter;
  
                            targets.forEach((target, i) => {
                                if (i === targets.length - 1) {
                                    const fourthLetter = this.#createLetter(i);
                                    letterContainer.append(fourthLetter);
                                }
  
                                if (i > 1) this.hideSVGCaption(i);
  
                                this.setLetter(i + 1, target, i === targets.length - 1);
                            });
  
                            this.updateLetterSessionStorage(1, cardSettings.target);
                            this.updateLetterSessionStorage(2, '*Not Applicable');
                            this.updateLetterSessionStorage(3, '*Not Applicable');
  
                            this.generator.active.letter = curentActiveLetter;
                        }, 450);
  
                        // Set active gallery to greek letter 1
                        this.showActiveGallery('letter', 1);
  
                    } else if (this.settings.usesFourthLetter) {
                        if (!cardSettings.target.includes('fiji') && !cardSettings.target.includes('sigma, ')) {
                            const fourthLetter = this.generator.letters.roots.pop();
                            fourthLetter.remove();
                            this.settings.usesFourthLetter = !this.settings.usesFourthLetter;
                            const rootLetter = [...this.generator.letters.roots[currentIndex - 1].querySelectorAll('image')];
  
                            rootLetter.forEach((image) => transitionContainer(image, image.getAttribute('href')));
                            setTimeout(() => {
                                this.setLetter(currentIndex, cardSettings.target);
                                this.updateLetterSessionStorage(currentIndex, cardSettings.target);
  
                                [2, 3].forEach((num) => {
                                  this.showSVGCaption(num);
                                  this.setLetter(num, '*not applicable');
                                  this.updateLetterSessionStorage(num, '*not applicable');
                                });
                            }, 450);
  
                        } else {
                            const rootLetters = [...this.generator.letters.roots].flatMap((root) => [...root.querySelectorAll('image')]);
                            rootLetters.forEach((image) => transitionContainer(image, image.getAttribute('href')));
                            
                            const targets = cardSettings.target.split(', ');
                            targets.forEach((target, i) => this.setLetter(i + 1, target));
  
                            this.updateLetterSessionStorage(1, cardSettings.target);
  
                        }
                    } else {
                        const rootLetter = [...this.generator.letters.roots[currentIndex - 1].querySelectorAll('image')];
  
                        rootLetter.forEach((image) => transitionContainer(image, image.getAttribute('href')));
                        setTimeout(() => this.setLetter(currentIndex, cardSettings.target), 450);
                        this.updateLetterSessionStorage(currentIndex, cardSettings.target);
                    }
  
                default:
                    break;
            }
  
            this.hideActiveGallery();
        });
  
        rootElement.append(clickableCard);
        return rootElement;
    }
  
    setNavigationText(relativeBoldOption, updateValue) {
        console.log('setting navigaiton text', relativeBoldOption);
        if (!relativeBoldOption.buttonDom) return;
        console.log('setting navigaiton text 222', relativeBoldOption);
        const buttonText = relativeBoldOption.buttonDom;
        if (!buttonText.innerHTML.includes('<br>')) {
            buttonText.innerHTML = buttonText.innerHTML + ` <br><span class="navigation-option-selected">${updateValue}</span>`;
  
        } else {
            const navigationText = buttonText.lastElementChild;
            navigationText.textContent = updateValue;
        }
  
        
    }
  
  
    setBoldOptionViaGuess(option, value) {
        if (!option.optionDom || option.optionDom.value !== '') return;
  
        
        const boldOptionValues = [...option.optionDom.children].filter((child) => child.value !== '').map((child) => child.value);
        const potentialTarget = boldOptionValues.find((option) => option.includes(value) || value.includes(option));
        if (!potentialTarget) return;
  
        this.setBoldOption(option, potentialTarget);
    }
  
    setBoldOption(option, value) {
        if (!option.optionDom) return;
  
        const __boldChangeEvent = new CustomEvent('change');
        let target = value;
  
        if (option.type == 'letter') {
            const lettered = (value) => {
                if (value === '*not applicable') {
                    return '*Not Applicable'; 
                } else if (value === `upsilon - ram head`) {
                    return "Upsilon - Ram Head";
                } else if (value === 'sigma alpha epsilon pi') {
                    return "Sigma Alpha Epsilon Pi";
                } else if (value === 'fiji letters') {
                    return "FIJI Letters";
                }
  
                return value.charAt(0).toUpperCase() + value.slice(1);
            };
  
            target = lettered(value);
        }
        
        try {
            option.optionDom.value = target;
            option.optionDom.dispatchEvent(__boldChangeEvent);
            option.activeValue = target;
            
            console.log('should change value', target, option, value);
        } catch (err) {
            console.log(err);
        }
    }
  
    generateGalleryTextCards(boldOptionSets = []) {
        if (document.body.dataset.templateName.includes('customizations-')) return;
  
        const textOptions = this.generator.domOptions.filter((option) => option.type != 'pattern' && option.type !== 'border' && option.type != 'garment');
  
      console.log('text options', textOptions);
        
        const textCardData = textOptions.map((option) => {
            const otherOptionCardData = {
                title: option.title,
                data: [],
                type: this.convertOptionTitleToGalleryType(option.title),
            };
  
            const options = [...option.optionDom.children].filter((option) => option.value !== '').map((option) => this.#createGalleryCard(otherOptionCardData.type, option, 'text'));
            otherOptionCardData.data.push(...options);
  
            return otherOptionCardData;
        });
  
        const loaded = this.generator.active.gallery.loaded;
        textCardData.forEach((textCard) => {
            if (textCard.title.includes('Greek Letter')) {
                loaded.letters.push(textCard);
            } else {
                let setToPush = loaded.otherOptions[0];
    
                if (textCard.title.includes('2') && this.settings.isPackage) {
                    setToPush = loaded.otherOptions[1];
                }
    
                setToPush.push(textCard);
            }
  
        });
    }
  
    #generateGalleryCards(boldOptionSets = []) {
        if (!this.apiData.borders[0].file.includes('somethinggreek')) return;
        const patterns = this.apiData.patterns;
        const borders = this.apiData.borders;
        const garments = this.apiData.garments;
        const letters = this.apiData.letters;
        
        const loaded = this.generator.active.gallery.loaded;

        //console.log('generategallerycards::: letters', letters);
  
        const garmentGalleryCards = garments.filter((garmentList) => garmentList.garment_list_id ).map((garmentList) => garmentList.garment_list_data?.map((garment) => this.#createGalleryCard('garment', garment)));
        garmentGalleryCards.forEach((galleryCard, i) => loaded.garments[i].push(...galleryCard));
  
        const patternGalleryCards = patterns.map((pattern) => this.#createGalleryCard('pattern', pattern));
        loaded.patterns.push(...patternGalleryCards);
  
        const borderGalleryCards = borders.map((border) => this.#createGalleryCard('border', border));
        loaded.borders.push(...borderGalleryCards);
  /*
        const letterGalleryCards = letters.map((letter) => this.#createGalleryCard('letter', letter));
        loaded.letters.push(...letterGalleryCards);
  */
       // document.querySelector('.letter-generator__active-gallery > ul').prepend(...letterGalleryCards, ...garmentGalleryCards, ...borderGalleryCards, ...patternGalleryCards);
    }
  
    
    #populateGeneratorDomOptions(boldOptionSets) {
        const productForm = this.productInfo.querySelector('product-form');
  
        const convertToActiveProductNum = (type, title) => {
            if (type === 'letter') {
                return 0;
  
            } else if (title.includes('2')) {
                return 2;
            }
  
            return 1;
        }
  
        const res = [...boldOptionSets]
            .flatMap((sets) => [...sets.querySelectorAll('.bold_option')])
            .filter((set) => {
              if (set.className.includes('hidden') || set.className.includes('radio')) {
                return false;
              }
  
              const setContent = set.querySelector('.bold_option_title').textContent.trim().replace(/\*/, '');
              
              if (setContent.includes('embroidery') || setContent.includes('embroider')) {
                return false;
              }
  
              return set;
            })
            .map((pairs) => {
              //console.log('pair, pairs', pairs);
                // The replace removes '*' if a required Option
                const title = pairs.querySelector('.bold_option_title').textContent.trim().replace(/\*/, ''); 
                const optionDom = () => {
                    if (pairs.className.includes('dropdown')) {
                        return pairs.querySelector('select');
                    }
  
                    return null;
                }
                const type = this.convertOptionTitleToGalleryType(title);
  
                const hiddenDom = () => {
                    if (!productForm || (type !== 'pattern' && type !== 'border' && type !== 'garment')) return '';
  
                    const hiddenInput = document.createElement('input');
                    hiddenInput.type = 'hidden';
                    hiddenInput.name = '_letterGenerator-' + title;
                    productForm.append(hiddenInput);
  
                    return hiddenInput;
                }
  
                return {
                    title: title,
                    type: type,
                    optionDom: optionDom(),
                    hiddenDom: hiddenDom(),
                    activeValue: '',
                    activeProduct: convertToActiveProductNum(type, title),
                    activeFiles: [],
                }
            });
  
  
        this.generator.domOptions.push(...res);
  
      //console.log('res is', res);
    }
  
    convertOptionTitleToGalleryType = (optionTitle) => {
        if (optionTitle.includes('Letter Color / Pattern')) {
            return 'pattern';
  
        } else if (optionTitle.includes('Border Color')) {
            return 'border';
  
        } else if (optionTitle.indexOf('Greek Letter') !== -1) {
            return 'letter'
  
        } else if (optionTitle.includes('Color')) {
            return 'garment';
  
        }
  
        return optionTitle.replace(/\s?(\/|\&)\s?/, ' ').toLowerCase().split(' ').join('-');
    }
  
    #generateOptionNavigation() {
        const domOptions = this.generator.domOptions;
        const listContainer = this.querySelector('.generator-navigation-list');
        if (domOptions.length === 0 || !listContainer) return;
  
        const navButtons = [];
  
        for (let i = 0; i < domOptions.length; i++) {
            // Used for setting gallery type
            domOptions[i].type = this.convertOptionTitleToGalleryType(domOptions[i].title);
          //console.log('opt type', domOptions[i].type);
            if (domOptions[i].type == 'did-you-update-the-#-of-characters-below?'
                || domOptions[i].type == 'garment-to-customize'
               ) {
                    continue;
                }
  
  
            if (domOptions[i].title.match(/Greek\sLetter\s#?\d/)) {
              continue;
              
            } else if (!this.settings.isPackage && domOptions[i].title == 'Size') {
              continue;
  
            } else if ((domOptions[i].title.includes('Embroidery') || domOptions[i].title.includes('Beanie'))) {
              continue;
            }
            
            const currOption = domOptions[i];
            const navigationButton = createCard(currOption.title);
  
            navigationButton.addEventListener('click', (e) => {
                e.preventDefault();
  
                this.openActiveGallery(domOptions[i].type);
            });
  
            currOption.buttonDom = navigationButton;
            navButtons.push(currOption.buttonDom);
        }
  
  
        if (!this.settings.isPackage) {
            listContainer.append(...navButtons);
        } else {
            const chunk1 = navButtons.slice(0, navButtons.length / 2);
            const chunk2 = navButtons.slice(navButtons.length / 2, navButtons.length);
  
            listContainer.append(...chunk1, ...chunk2);
        }
        
  
        function createCard(label) {
            const cardRoot = document.createElement('button');
            cardRoot.dataset.activeProduct = 1;
  
            if (label.includes('2')) {
                cardRoot.dataset.activeProduct = 2;
                cardRoot.style.display = 'none';
            }
  
            cardRoot.className = 'letter-generator-buttonify';
            //cardRoot.style.backgroundColor = 'lightblue';
            // Todo: Shadow Root Styles
  
            cardRoot.innerHTML = `<span>${label}</span>`;
  
            return cardRoot;
        }
    }
  
    #createLetter(index) {
        const htmlIndex = index + 1;
        const rootElement = document.createElement('li');
        rootElement.id = `ltrgen-greek-${htmlIndex}`;
        rootElement.setAttribute('aria-label', `Greek Letter ${htmlIndex}`);
  
        rootElement.innerHTML = `
            <figure aria-labelledby="letter-title-${htmlIndex} letter-desc-${htmlIndex}">
                <svg class="letter-svg"
                    width="140pt"
                    height="140pt"
                    viewBox="0 0 166 166"
                    preserveAspectRatio="xMidYMid meet"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-labelledby="letter-title-${htmlIndex} letter-desc-${htmlIndex}"
                >
                    <title id="letter-title-${htmlIndex}"></title>
                    <desc id="letter-desc-${htmlIndex}"></desc>
  
                    <defs>
                        <clipPath id="border-${htmlIndex}">
                            <path />
                        </clipPath>
  
                        <clipPath id="letter-${htmlIndex}">
                            <path />
                        </clipPath>
                    </defs>
  
                    <image class="border-image border-image-${htmlIndex}" clip-path="url(#border-${htmlIndex})" height="100%" width="100%" href="" />
                    <image class="letter-image letter-image-${htmlIndex}" clip-path="url(#letter-${htmlIndex})" height="100%" width="100%" href="" />
                </svg>
  
                <figcaption class="select-letter" 
                    data-num="${htmlIndex}" 
                    aria-label="Letter ${htmlIndex}">
                    ${ this.settings.isGroup || index >= 3 ?
                        `<span></span>`
                        : `<button id="change-letter-${htmlIndex}" data-num="${htmlIndex}"  aria-label="Change Letter ${htmlIndex}">Change Letter ${htmlIndex}</button>`
                    }
                </figcaption>
            </figure>
        `;
  
        [this.generator.letters.letter, this.generator.letters.border].forEach((type) => {
            type.paths[index] = rootElement.querySelector(`clipPath#${type.id}-${htmlIndex}`);
            type.images[index] = rootElement.querySelector(`.${type.id}-image-${htmlIndex}`);
        });
  
        this.generator.letters.roots[index] = rootElement;
  
        //this.setLetter(index, this.settings.defaultLetters[index - 1]);
        
  
        if (!this.settings.isGroup && index < 3) {
            const changeLetterButton = rootElement.querySelector('button');
  
            changeLetterButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.openActiveGallery('letter', htmlIndex);
            });
  
            const generatorDom = this.generator.domOptions.filter((option) => option.title.match((/Greek\sLetter\s#?\d/)) && option.title.includes(changeLetterButton.dataset.num));
            generatorDom[0].buttonDom = changeLetterButton;
  
        }
  
        return rootElement;
    }
  
    setLetter(index, letter, isDefault = false) {
        if (!index || index === 0 || !letter) return;
        
        const generatorLettersData = this.generator.letters;
        const greekLetter = letter.toLowerCase().replace('*not applicable', 'none').replace(/ - ram head/, 'Rams');
        const apiLetterData = this.apiData.letterPaths.letter.find((obj) => obj.key == greekLetter);
        const apiBorderData = this.apiData.letterPaths.border.find((obj) => obj.key == greekLetter);
  
        console.log('setting letter', index, letter, this.apiData);
  
        // Set Svg Data
        const rootSvg = generatorLettersData.roots[index - 1];
        rootSvg.setAttribute('data-greek', greekLetter);
  
        // Set Letter Data
        const letterClipPath = generatorLettersData.letter.paths[index - 1];
        const letterPath = letterClipPath.firstElementChild;
  
        letterPath.setAttribute('d', apiLetterData.data.path);
        letterClipPath.setAttribute('transform', apiLetterData.data.offset);
  
        // Set Border Data
        const borderClipPath = generatorLettersData.border.paths[index - 1];
        const borderPath = borderClipPath.firstElementChild;
  
        borderPath.setAttribute('d', apiBorderData.data.path);
        borderClipPath.setAttribute('transform', apiBorderData.data.offset);
  
        // Set default pattern and border images on load
        if (isDefault) {
            const defaultPattern = index < 3 ? this.generator.default.pattern : generatorLettersData.letter.images[index - 2].getAttribute('href');
            const defaultBorder = index < 3 ? this.generator.default.border : generatorLettersData.border.images[0].getAttribute('href');
  
            generatorLettersData.letter.images[index - 1].setAttribute('href', defaultPattern);
            generatorLettersData.border.images[index - 1].setAttribute('href', defaultBorder);
        } 
  
        this.updateSVG(index);
    }
  
    updateLetterSessionStorage(index, letter) {
      if (index === 4) return;
  
      sessionStorage.setItem(getSessionKey(index), letter);
      console.log(sessionStorage);
    }
  
    updateSVG(num) {
        if (typeof num !== 'undefined') {
          update(num, this.generator);
  
        } else {
          const iterateTo = (!this.settings.isSpecialGroup) ? this.settings.defaultLetters.length : 4;
  
          for (let i = 0; i < iterateTo; i++) {
            update(1 + i, this.generator);
          }
        }
        
        function update(num, generator) {
            const svgRoot = generator.letters.roots[num - 1];
            const svgTitle = svgRoot.querySelector('title');
            const svgDesc = svgRoot.querySelector('desc');
            const letter = svgRoot.dataset.greek;
  
            svgTitle.textContent = `Letter ${num}: ${letter.toUpperCase().replace('FIJI_', '')}`;
            //svgDesc.textContent = 
            letter === 'none' ? svgRoot.classList.add('js-no-letter') : svgRoot.classList.remove('js-no-letter');
        }
    }
  
    showSVGCaption(num) {
        const svgRoot = this.generator.letters.roots[num - 1];
        if (!svgRoot) return;
  
        const figcaption = svgRoot.querySelector('figcaption');
        figcaption.style.display = 'block';
    }
  
    hideSVGCaption(num) {
        const svgRoot = this.generator.letters.roots[num - 1];
        if (!svgRoot) return;
  
        const figcaption = svgRoot.querySelector('figcaption');
        figcaption.style.display = 'none';
    }
  
    initLetters() {
        const letterContainer = this.querySelector('.output__letters-list');
        if (!letterContainer) return;
        const createLetter = (i) => this.#createLetter(i);
  
        const lettersToCreate = [0, 1, 2].map((index) => createLetter(index));
        if (this.settings.usesFourthLetter) lettersToCreate.push(createLetter(3));
        letterContainer.append(...lettersToCreate);
    }
    
  
    parseShopifyTag() {
        const productTitleDOM = this.productInfo.querySelector('.letter-generator-tag');
  
        // console.log('title dom', productTitleDOM);
        const productTitle = productTitleDOM.textContent.trim();
        const customerMetafields = productTitleDOM.dataset.greekMetafieldSaved;
        const liquidTag = productTitleDOM.dataset.liquid.replace(/letter-/, '').split('-');
        const productStyles = this.shopifyProuctStyles;

        const lastWordOfTag = liquidTag[liquidTag.length - 1];
  
        /* Prep Garment Data (Product Style, Packages, Customization Product) */
        if (lastWordOfTag === 'package' || lastWordOfTag === 'pack') {
            /* Handle Package Items / Both Size && Size 2 */
            this.settings.isPackage = true;
            // console.log('Found Package');
  
            // Prelim check because some product tags do not have 
            // package appended, so  this would remove that package
            // tag on the prodcuts that contain this keyword
            if (lastWordOfTag=== 'package' || lastWordOfTag === 'pack') liquidTag.pop();
  
  
            // Since we've detected a package,
            // the last 2 tags should be our styles
            productStyles.unshift(liquidTag.pop());
            productStyles.unshift(liquidTag.pop());
  
  
        
        } else if (productTitle.match(/\(Letters\sOnly\)/) 
            || (lastWordOfTag == 'customization')
            || (productTitle.match(/Additional Twill/) && productTitle.match(/(Left|Right)\s?Chest/))
        ) {
            /* Handle Customization Products */
            this.settings.isCustomization = true;
            productStyles.unshift(liquidTag.pop());
  
            // Hide Garment Options
            //  document.querySelector('.options-dd.manual-drop.garment-options').style = 'display: none;';
        
  
        } else if (lastWordOfTag == 'starsandstripes') {
            console.log('stars and stripes product');
            this.settings.specialProductType = lastWordOfTag;
            /* Handle Hidden Input for Special Items (Border Only / Letter Only Products) */

        } else {
            /* Handle Single Items / Only Size */  
            productStyles.unshift(liquidTag.pop());
        }
  
  
  
        /* Prep Default Letter Settings */
        const defaultLetters = this.settings.defaultLetters;
        const tempDefaultLetters = [];
  
  
        // First Check Tag - Note that we change the
        // default letters via metafields or sesssion storage
        // which happens after this switch block
        switch(liquidTag[0]) {
            case 'main':
                tempDefaultLetters.push('beta');
                tempDefaultLetters.push('alpha');
                tempDefaultLetters.push('zeta');
                break;

            case 'sor':
                tempDefaultLetters.push('delta');
                tempDefaultLetters.push('phi');
                tempDefaultLetters.push('epsilon');
                break;

            case 'frat':
                tempDefaultLetters.push('tau');
                tempDefaultLetters.push('kappa');
                tempDefaultLetters.push('epsilon');
                break;
  
            case 'sigmaalphaepsilonpi':
                tempDefaultLetters.push('sigma alpha epsilon pi');
                tempDefaultLetters.push('*not applicable');
                tempDefaultLetters.push('*not applicable');
  
                this.settings.isGroup = true;
                this.settings.isSpecialGroup = true;
                this.settings.usesFourthLetter = true;
                break;
  
            case 'fiji':
                tempDefaultLetters.push('fiji letters');
                tempDefaultLetters.push('*not applicable');
                tempDefaultLetters.push('*not applicable');
  
                this.settings.isGroup = true;
                this.settings.isSpecialGroup = true;
                this.settings.usesFourthLetter = true;
                break;
  
            default:
                const tagLetter1 = liquidTag.shift();
                const tagLetter2 = liquidTag.shift();
                const tagLetter3 = liquidTag[2] !== liquidTag[liquidTag.length - 1] ? liquidTag.shift() : '*not applicable';
                tempDefaultLetters.push(tagLetter1);
                tempDefaultLetters.push(tagLetter2);
                tempDefaultLetters.push(tagLetter3);
  
                this.settings.isGroup = true;
                if (tempDefaultLetters.join(' ') === 'sigma iota alpha') this.settings.isSigmaIotaAlpha = true;
                break;
        }
  
  
        // Next check metafields && session storage
        // for previous values entered into site
        // This check is only for NON-GROUP products
        // i.e. Greek Letter 1, 2, & 3 opposed to '[Group] Letter [Product]'
        if (!this.settings.isGroup && !this.settings.isSpecialGroup) {
            if (customerMetafields === 'true') {
                tempDefaultLetters[0] = productTitleDOM.dataset.greek1;
                tempDefaultLetters[1] = productTitleDOM.dataset.greek2;
                tempDefaultLetters[2] = productTitleDOM.dataset.greek3;
  
                this.settings.useSavedData = true;
  
            } else if (sessionStorage.getItem(sessionStorageKeys.greek1) && sessionStorage.getItem(sessionStorageKeys.greek1) != '') {
                tempDefaultLetters[0] = sessionStorage.getItem(sessionStorageKeys.greek1).toLowerCase();
                tempDefaultLetters[1] = !sessionStorage.getItem(sessionStorageKeys.greek2) ? '*not applicable' : sessionStorage.getItem(sessionStorageKeys.greek2).toLowerCase();
                tempDefaultLetters[2] = !sessionStorage.getItem(sessionStorageKeys.greek3) ? '*not applicable' : sessionStorage.getItem(sessionStorageKeys.greek3).toLowerCase();
  
                this.settings.useSavedData = true;
            }
        }
  
        // Final settings updates
        if (!this.settings.isSpecialGroup && (tempDefaultLetters[0] == 'sigma alpha epsilon pi' || tempDefaultLetters[0] == 'fiji letters')) {
          //this.settings.isGroup = true;
          this.settings.isSpecialGroup = true;
          this.settings.usesFourthLetter = true;
        }
  
        // Set Default Letters
        tempDefaultLetters.forEach((letter) => defaultLetters.push(letter));
        console.log('default letters is now', defaultLetters);
  
        this.settings.isCustomization = true;
  
    } // End parseShopifyTag()
  
  
    prepareAPIData() {
        const apiData = this.apiData;
  
        apiData.patterns = this.#fetchData(1);
        apiData.borders = this.#fetchData(2);
        apiData.garments[0] = this.#fetchData(3);
        apiData.letters = this.#fetchData(4);
        //letter: JSON.parse(document.getElementById('ltrgen-letters').textContent),
        //border: JSON.parse(document.getElementById('ltrgen-borders').textContent),
  
        const lettersFromDom = JSON.parse(document.getElementById('ltrgen-letters').textContent);
        const bordersFromDom = JSON.parse(document.getElementById('ltrgen-borders').textContent);
        apiData.letterPaths.letter = Object.keys(lettersFromDom).map((key) => { return { key: key, data: lettersFromDom[key] } });
        apiData.letterPaths.border = Object.keys(bordersFromDom).map((key) => { return { key: key, data: bordersFromDom[key] } });
  
        if (this.settings.isPackage) {
            this.apiData.garments[1] = this.#fetchData(3, true);
        }
    } // End prepareAPIData()
  
  
    #fetchData(key, loadPackage = false) {
        let url = '';
        const tagId = loadPackage === true ? this.shopifyProuctStyles[1] : this.shopifyProuctStyles[0];
  
        /*
  
        switch (key) {
            case 1:
              url = '//something-greek.herokuapp.com/patterns/get';
              break;
            case 2:
              url = '//something-greek.herokuapp.com/borders/get';
              break;
            case 3:
              url = '//something-greek.herokuapp.com/backgrounds/get?' + new URLSearchParams({ tag_id: tagId });
    
              break;
            case 4:
              url = '//something-greek.herokuapp.com/letters/get';
              break;
        }
    
        try {
            let res = await fetch(url);
            const data = await res.json();
  
            return data;
  
        } catch (error) {
            console.log(error);
        }
        */
  
      if (key === 1) {
        const patternList = JSON.parse(document.getElementById('pattern-list').textContent);
        return patternList;
        
      } else if (key === 2) {
        const borderList = JSON.parse(document.getElementById('border-list').textContent);
        return borderList;
  
      } else if (key === 3) {
        const garmentList = document.getElementById('garment-list') ? JSON.parse(document.getElementById('garment-list').textContent) : [[], []];
  
        return loadPackage ? garmentList[garmentList.length - 1] : garmentList[0];
      }
    } // End #fetchData()
  }
  customElements.define('letter-generator', LetterGenerator);
  
  function waitForElement(selector, source = document) {
    return new Promise(resolve => {
      if (source.querySelector(selector)) {
          return resolve(source.querySelector(selector));
      }
  
      const observer = new MutationObserver(mutations => {
          if (source.querySelector(selector)) {
              observer.disconnect();
              resolve(source.querySelector(selector));
          }
      });
  
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
    });
  }